export enum RouteBasePath {
  launchpad = 'launchpad',
  Year2024Summary = '2024-syn-score',
  earn = 'earn',
  portfolio = 'portfolio',
  trade = 'trade',
  market = 'market',
  referral = 'referral',
}
